import theme from "theme";
import { colors } from "theme/palette";

import Text from "components/Text";

export interface IStatusTag {
  text: "missing" | "edited" | "N/A";
  backgroundColor:
    | typeof colors.teal20
    | typeof colors.red40
    | typeof colors.gray20;
}

const StatusTag = ({ text, backgroundColor }: IStatusTag) => (
  <Text
    fontSize="13px"
    fontWeight={500}
    alignSelf="center"
    padding={theme.spacing(0.2, 1)}
    borderRadius={0.5}
    sx={{ backgroundColor }}
  >
    {text}
  </Text>
);

export default StatusTag;
